<template>
  <modal
    class="ce-forgotPassword"
    @close="close"
    :headline="$t('forgotPassword.modalHeadline')"
    :description="hasFinished ? null : $t('forgotPassword.modalDescription')">
    <div class="ce-modalContent ce-forgotPassword-content">
      <alert
        v-if="hasMessage"
        :message="message.content"
        :type="message.type"
        :closable="false" />

      <v-form
        v-if="!hasFinished"
        @submit="submit">
        <validated-input
          name="email"
          :label="$t('forgotPassword.email')"
          autocapitalize="none"
          rules="required|email" />

        <div>
          <button
            class="ce-btn ce-btn-light ce-btn--fullWidth"
            :disabled="loading"
            type="submit">
            <template v-if="loading">
              <fa-icon
                icon="spinner"
                spin />
            </template>
            <template v-else>
              {{ $t('forgotPassword.submitCta') }}
            </template>
          </button>
        </div>
      </v-form>

      <div class="mt2 ce-forgotPassword-subActions">
        <div class="ce-userLogin-register">
          <a
            href="#"
            @click.prevent="$store.dispatch('user/showLogin')">
            <fa-icon icon="long-arrow-alt-left" />
            {{ $t('forgotPassword.backToLoginCta') }}
          </a>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      message: {
        type: 'success',
        content: null
      }
    };
  },
  computed: {
    hasMessage() {
      return this.message && this.message.content;
    },
    hasFinished() {
      return this.hasMessage && this.message.type === 'success';
    }
  },
  methods: {
    async submit(values) {
      this.loading = true;
      this.message = {};

      try {
        await this.$store.dispatch('user/requestPasswordReset', values.email);
      } catch (e) {
        // noop
      }

      this.message = {
        type: 'success',
        content: this.$t('forgotPassword.successMessage')
      };

      this.loading = false;
    },
    close() {
      this.$store.dispatch('user/hideForgotPassword');
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-forgotPassword-content {
  > div {
    .mb3;
  }

  .ce-forgotPassword-subActions {
    .ce-pageHeader .ce-pageHeader-wrapper & {
      a {
        color: @color-light;
      }
    }
  }
}
</style>
